import React, { useEffect, useRef } from 'react';
import { StyledAccordionSingle } from './StyledAccordionSingle';
import AccordionContent from '../AccordionContent'
const AccordionSingle = ({title, isOpen, isDouble, index, changeCurrent, content}) => {

  const contentEl = useRef();

  const toggleOpen = () => {
    changeCurrent(index)
    setTimeout(() => contentEl.current.parentNode.parentNode.scrollIntoView({behavior: "smooth"}), 500 )
  }

  const resizeFn = () => {

    if(contentEl.current.clientHeight !== 0){
      let height = contentEl.current.querySelector('.accordion--height').clientHeight;
      contentEl.current.style.height =  `${height}px` ;
    }
  }

  useEffect(()=>{
    let height = contentEl.current.querySelector('.accordion--height').clientHeight;
    contentEl.current.style.height = isOpen ? `${height}px` :  0;
  },[isOpen])

  useEffect(()=>{
    window.addEventListener('resize', resizeFn)
    return () => {
      window.removeEventListener('resize', resizeFn);
    };
  }, [])

  return (
    <React.Fragment>
      {
        <StyledAccordionSingle>
          <div className="accordion--single">
            <div className="accordion--title-wrap" onClick={toggleOpen}>
              <h6 className="big--title">
                {title}
              </h6>
              <div className={`accordion--icon ${isOpen ? 'accordion--open' : ''}`}>
                <div className="line"></div>
                <div className="line"></div>
              </div>
            </div>
            <div ref={contentEl} className={`accordion--content ${isDouble ? 'accordion--content-double' : ''}`}>
              <div className="accordion--height">
              {
                content.map((key, i) => {
                  return  <AccordionContent key={i} isDouble={isDouble} innerContent={key} />
                })
              }
              </div>
            </div>
          </div>
        </StyledAccordionSingle>
      }
    </React.Fragment>
  );
};



export default AccordionSingle;
